import { render, staticRenderFns } from "./Less.vue?vue&type=template&id=10349534&"
import script from "./Less.vue?vue&type=script&lang=ts&"
export * from "./Less.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports